import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store/hooks";

export interface NewTableWaiterChoice {
  /** Влезлият — избран по подразбиране и най-отгоре в избора на сервитьор. */
  me: { id: number; name: string };
  /** Защо изборът е недостъпен (локален режим), иначе `undefined`. */
  lockedReason?: string;
}

/**
 * Изборът на сервитьор преди „Нова маса" (`NewTableFlow`) — само с правото
 * `view_all_users_bills` („Откриване и закриване на сметки на други
 * оператори"); без него `undefined` и е само номерът, както досега. В локален
 * режим (`lockedReason`) изборът се пропуска: касата не отваря маса на друг
 * сервитьор.
 */
export const useNewTableWaiterChoice = (): NewTableWaiterChoice | undefined => {
  const { t } = useTranslation();
  const canChoose = useAppSelector((state) =>
    state.auth.permissions.some((permission) => permission.name === "view_all_users_bills"),
  );
  const userId = useAppSelector((state) => state.auth.userId);
  const myName = useAppSelector((state) => state.auth.names || state.auth.username || "");
  const edgeLocal = useAppSelector((state) => state.edge.mode === "local");
  const lockedReason = edgeLocal ? t("edge.unavailableOffline") : undefined;

  return useMemo(
    () =>
      canChoose && userId != null
        ? { me: { id: userId, name: myName }, lockedReason }
        : undefined,
    [canChoose, userId, myName, lockedReason],
  );
};
